<template>
  <button
      :class="{'--active' : scrollTop > 300}"
      class="to-top"
      @click="scrollToTop"><img src="@/assets/img/arrow-circle-up-icon.svg" alt="to-top"/></button>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'ScrollToTop',
  data: () => ({
    scrollTop: 0,
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.scrollY;
    },
    scrollToTop() {
      VueScrollTo.scrollTo('#navbar-section', 350, { easing: 'linear' });
    },
  },
};
</script>
